import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Icon from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";

import { colors } from "../../theme";
import { toggleMenu } from "../../actions";

const HeaderElement = styled.header`
  background-image: url(${require("../../assets/images/zebra2_blue.svg")});
  background-size: cover;
  background-position: center;
  text-align: center;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderTitle = styled.h1`
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  letter-spacing: 0.2px;
  line-height: 38px;
  margin: 0px;
  text-overflow: ellipsis;

  @media (min-width: 575px) {
    font-size: 40px;
  }
`;

const HeaderTitleLink = styled(Link)`
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  line-height: 18px;
  letter-spacing: 0.2px;
  margin: 0px;
  text-decoration: none;

  @media (min-width: 575px) {
    font-size: 40px;
    line-height: 38px;
  }
`;

const Small = styled.span`
  font-size: 16px;
  color: white;
  font-weight: normal;
  display: none;

  @media (min-width: 575px) {
    display: block;
  }
`;

const HomeLink = styled(Link)`
  color: white;
  border: 2px solid ${colors.darkBlue};
  background-color: ${colors.darkBlue};
  padding: 1px 2px;
  border-radius: 4px;
  color: white;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.4s;
  line-height: 16px;

  &:hover {
    color: ${colors.darkBlue};
    background-color: transparent;
  }
`;

const BurgerLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 30px;
  transition: all 0.3s;

  &:hover {
    color: ${colors.yellow};
  }
`;

const LogoImg = styled.img`
  max-height: 20px;
  float: right;

  @media (min-width: 575px) {
    max-height: 40px;
  }
`;

const Left = styled.div`
  min-width: 100px;
  text-align: left;
`;
const Center = styled.div``;
const Right = styled.div`
  min-width: 100px;
`;

const Header = ({ city, title, menu, toggleMenu, hideMenu }) => (
  <HeaderElement>
    <Left>
      {!hideMenu && (
        <BurgerLink
          href="#toggleMenu"
          onClick={e => {
            e.preventDefault();
            toggleMenu(!menu.visible);
          }}
        >
          <Icon icon={["fas", "bars"]} />
        </BurgerLink>
      )}
    </Left>
    <Center>
      {city ? (
        <div>
          <HeaderTitle>
            {city.name}{" "}
            <Small>
              <HomeLink to="/">andere gemeente</HomeLink>
            </Small>
          </HeaderTitle>
        </div>
      ) : (
        <HeaderTitleLink to="/">
          {title ? title.toLowerCase() : "mnm kieskaart"}
        </HeaderTitleLink>
      )}
    </Center>
    <Right>
      {!hideMenu && (
        <LogoImg
          src={require("../../assets/images/witlogo_gelemusic.png")}
          alt="MNM"
        />
      )}
    </Right>
  </HeaderElement>
);

const mapStateToProps = state => {
  return { menu: state.menu };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleMenu: visible => {
      dispatch(toggleMenu(visible));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js